import { render, staticRenderFns } from "./CPTransactionDetails.vue?vue&type=template&id=39b84d34&scoped=true&"
import script from "./CPTransactionDetails.vue?vue&type=script&lang=ts&"
export * from "./CPTransactionDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CPTransactionDetails.vue?vue&type=style&index=0&id=39b84d34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b84d34",
  null
  
)

export default component.exports